import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IUpdateCentro, ICreateCentro } from '../interfaces/centros.interface';
import { ICreateEmpleo, IUpdateEmpleo } from '../interfaces/empleos.interface';
import { ICreatePersona, IUpdatePersona } from '../interfaces/personas.interface';
import { ICreateGrupo, IIntegrante, IUpdateGrupo } from '../interfaces/grupos.interface';
import { ICreateServicio, IUpdateServicio } from '../interfaces/servicios.interface';
import { ICreateBeneficiario, ILoadPadron, IUpdateBeneficiario } from '../interfaces/beneficiarios.interface';
import { ILogin } from '../interfaces/auth.interface';
import { ICreatePrograma, IUpdatePrograma } from '../interfaces/programas.insterface';
import { ICreateInstituciones, IUpdateInstituciones } from '../interfaces/instituciones.interface';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  url = 'https://impacta.iteso.mx/api/v1';
  // url = 'http://localhost:8080/api/v1';

  constructor(private http: HttpClient) {
  }

  // AUTH
  login(payload: ILogin) {
    const body = { ...payload };
    return this.http.post(`${this.url}/auth/login`, body);
  }

  getUser(token) {
    const body = { token };
    return this.http.post(`${this.url}/auth/user`, body);
  }

  // CRUD Centros
  getCentros() {
    return this.http.get(`${this.url}/centros`);
  }

  createCentro(payload: ICreateCentro) {
    const body = { ...payload };
    return this.http.post(`${this.url}/centros`, body);
  }

  updateCentro(id: string, payload: IUpdateCentro) {
    const body = { ...payload };
    return this.http.put(`${this.url}/centros/${id}`, body);
  }

  deleteCentro(id: string) {
    return this.http.delete(`${this.url}/centros/${id}`);
  }

  // CRUD Programas
  getProgramas() {
    return this.http.get(`${this.url}/programas`);
  }

  createProgramas(payload: ICreatePrograma) {
    const body = { ...payload };
    return this.http.post(`${this.url}/programas`, body);
  }

  updateProgramas(id: string, payload: IUpdatePrograma) {
    const body = { ...payload };
    return this.http.put(`${this.url}/programas/${id}`, body);
  }

  deleteProgramas(id: string) {
    return this.http.delete(`${this.url}/programas/${id}`);
  }

  // CRUD Instituciones
  getInstituciones() {
    return this.http.get(`${this.url}/instituciones`);
  }

  createInstituciones(payload: ICreateInstituciones) {
    const body = { ...payload };
    return this.http.post(`${this.url}/instituciones`, body);
  }

  updateInstituciones(id: string, payload: IUpdateInstituciones) {
    const body = { ...payload };
    return this.http.put(`${this.url}/instituciones/${id}`, body);
  }

  deleteInstituciones(id: string) {
    return this.http.delete(`${this.url}/instituciones/${id}`);
  }

  // CRUD Empleos
  getEmpleos() {
    return this.http.get(`${this.url}/empleos`);
  }

  createEmpleo(payload: ICreateEmpleo) {
    const body = { ...payload };
    return this.http.post(`${this.url}/empleos`, body);
  }

  updateEmpleo(id: string, payload: IUpdateEmpleo) {
    const body = { ...payload };
    return this.http.put(`${this.url}/empleos/${id}`, body);
  }

  deleteEmpleo(id: string) {
    return this.http.delete(`${this.url}/empleos/${id}`);
  }

  // CRUD Personas
  getPersonas() {
    return this.http.get(`${this.url}/personas`);
  }

  createPersona(payload: ICreatePersona) {
    const body = { ...payload };
    return this.http.post(`${this.url}/personas`, body);
  }

  updatePersona(id: string, payload: IUpdatePersona) {
    const body = { ...payload };
    return this.http.put(`${this.url}/personas/${id}`, body);
  }

  deletePersona(id: string) {
    return this.http.delete(`${this.url}/personas/${id}`);
  }

  // CRUD Grupos
  getGrupos() {
    return this.http.get(`${this.url}/grupos`);
  }

  createGrupo(payload: ICreateGrupo) {
    const body = { ...payload };
    return this.http.post(`${this.url}/grupos`, body);
  }

  updateGrupo(id: string, payload: IUpdateGrupo) {
    const body = { ...payload };
    return this.http.put(`${this.url}/grupos/${id}`, body);
  }

  deleteGrupo(id: string) {
    return this.http.delete(`${this.url}/grupos/${id}`);
  }

  addIntegranteGrupo(id: string, payload: IIntegrante) {
    const body = { ...payload };
    return this.http.post(`${this.url}/grupos/${id}/integrantes`, body);
  }

  deleteIntegranteGrupo(id:string, payload: IIntegrante) {
    const body = { ...payload };
    return this.http.request('delete', `${this.url}/grupos/${id}/integrantes`, {body});
  }

  getSesiones(id) {
    return this.http.get(`${this.url}/grupos/${id}/sesiones`);
  }

  getAsistencias(id) {
    return this.http.get(`${this.url}/grupos/${id}/asistencias`);
  }

  createAsistencias(payload: any) {
    const body = { ...payload };
    return this.http.post(`${this.url}/grupos/asistencias`, body);
  }

  // CRUD Servicios
  getServicios() {
    return this.http.get(`${this.url}/servicios`);
  }

  createServicio(payload: ICreateServicio) {
    const body = { ...payload };
    return this.http.post(`${this.url}/servicios`, body);
  }

  updateServicio(id: string, payload: IUpdateServicio) {
    const body = { ...payload };
    return this.http.put(`${this.url}/servicios/${id}`, body);
  }

  deleteServicio(id: string) {
    return this.http.delete(`${this.url}/servicios/${id}`);
  }

  // CRUD Beneficiarios
  getBeneficiarios() {
    return this.http.get(`${this.url}/beneficiarios`);
  }

  createBeneficiario(payload: ICreateBeneficiario) {
    const body = { ...payload };
    return this.http.post(`${this.url}/beneficiarios`, body);
  }

  updateBeneficiario(id: string, payload: IUpdateBeneficiario) {
    const body = { ...payload };
    return this.http.put(`${this.url}/beneficiarios/${id}`, body);
  }

  deleteBeneficiario(id: string) {
    return this.http.delete(`${this.url}/beneficiarios/${id}`);
  }

  getEstudioBeneficiario(id: string) {
    return this.http.get(`${this.url}/beneficiarios/${id}/estudio`);
  }

  updateEstudioBeneficiario(id: string, payload: object) {
    const body = { ...payload };
    return this.http.put(`${this.url}/beneficiarios/${id}/estudio`, body);
  }

  loadPadron(payload: ILoadPadron) {
    const body = { ...payload };
    return this.http.post(`${this.url}/beneficiarios/padron`, body);
  }

  // CRUD Formularios
  getFormularios() {
    return this.http.get(`${this.url}/formularios`);
  }

  getFormulariosAsignados(id) {
    return this.http.get(`${this.url}/formularios/asignados/${id}`);
  }

  getFormularioResponses(id) {
    return this.http.get(`${this.url}/formularios/responses/${id}`);
  }

  createFormularioAsignado(payload: any) {
    const body = { ...payload };
    return this.http.post(`${this.url}/formularios/asignados`, body);
  }

  createFormularioGrupo(payload: any) {
    const body = { ...payload };
    return this.http.post(`${this.url}/formularios/asignados/grupos`, body);
  }

  createFormularioCentro(payload: any) {
    const body = { ...payload };
    return this.http.post(`${this.url}/formularios/asignados/centros`, body);
  }

  createFormularioPrograma(payload: any) {
    const body = { ...payload };
    return this.http.post(`${this.url}/formularios/asignados/programas`, body);
  }

  createFormulario(payload: any) {
    const body = { ...payload };
    return this.http.post(`${this.url}/formularios`, body);
  }

  updateFormulario(id: string, payload: any) {
    const body = { ...payload };
    return this.http.put(`${this.url}/formularios/${id}`, body);
  }

  deleteFormulario(id: string) {
    return this.http.delete(`${this.url}/formularios/${id}`);
  }
}
